var ceil = Math.ceil,
    floor = Math.floor,
    round = Math.round,
    trunc = Math.trunc;
export function clamp(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
export function createClamp(min, max) {
  var clamper = function clamper(value) {
    return clamp(value, min, max);
  };

  return clamper;
}
export var clamp01 = createClamp(0, 1);
export function clampRound(value, min, max) {
  return clamp(round(value), ceil(min), floor(max));
}
export function createClampRound(min, max) {
  var finalMin = ceil(min);
  var finalMax = floor(max);

  var clamper = function clamper(value) {
    return clamp(round(value), finalMin, finalMax);
  };

  return clamper;
}
export function clampFloor(value, min, max) {
  return clamp(floor(value), ceil(min), floor(max));
}
export function createClampFloor(min, max) {
  var finalMin = ceil(min);
  var finalMax = floor(max);

  var clamper = function clamper(value) {
    return clamp(floor(value), finalMin, finalMax);
  };

  return clamper;
}
export function clampCeil(value, min, max) {
  return clamp(ceil(value), ceil(min), floor(max));
}
export function createClampCeil(min, max) {
  var finalMin = ceil(min);
  var finalMax = floor(max);

  var clamper = function clamper(value) {
    return clamp(ceil(value), finalMin, finalMax);
  };

  return clamper;
}
export function clampTrunc(value, min, max) {
  return clamp(trunc(value), ceil(min), floor(max));
}
export function createClampTrunc(min, max) {
  var finalMin = ceil(min);
  var finalMax = floor(max);

  var clamper = function clamper(value) {
    return clamp(trunc(value), finalMin, finalMax);
  };

  return clamper;
}